<template>
  <section class="MobileFilterFull rounded-t-3xl w-full fixed bottom-0 left-0 bg-white">
    <slot name="header"></slot>
    <slot name="body"></slot>
    <div class="px-6 py-8 flex justify-between shadow-lg border-top border-gray-200">
      <slot name="footer"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "MobileFilterFull",
}
</script>

<style scoped>
.MobileFilterFull {
  z-index: 200;
  height: 85%;

  display: grid;
  grid-auto-flow: column;
  grid-template: 80px auto 85px / auto;

  &_body {
    overflow-y: auto;
  }
}
</style>
